import { CryptoRewardsReducer } from 'components/features/rewards/rewardsPane/types/store'
import { createAction } from 'helpers/actionHelpers/createAction'

type UserRewardsStateReducerChangeStateActionPayload = Partial<CryptoRewardsReducer>

export class UserRewardsStateReducerChangeStateAction extends (
  createAction<'USER_REWARDS_STATE_REDUCER_CHANGE_STATE', UserRewardsStateReducerChangeStateActionPayload>('USER_REWARDS_STATE_REDUCER_CHANGE_STATE')
) {}


export type UserRewardsStateReducerActions =
  | UserRewardsStateReducerChangeStateAction
